import './style.css'
import World from './threeJsClass/World.js'

document.getElementById('link1').href = "./favicon/apple-touch-icon.png"
document.getElementById('link2').href = "./favicon/favicon-32x32.png"
document.getElementById('link3').href = "./favicon/favicon-16x16.png"
document.getElementById('link4').href = "./favicon/site.webmanifest"

new World()

const toggleButton = document.getElementById('toggleButton')
const colorPanel = document.getElementById('colorPanel')
const parametersList = document.getElementById('parametersList')
let isOpen = true

document.getElementById('toggleButtonImage').src = './chevron-down.png'

toggleButton.addEventListener('click', () => {
  if(isOpen){
    const height = parametersList.getBoundingClientRect().height

    colorPanel.style.transform = `translateY(${-height}px)`

    toggleButton.style.transform = "rotate(0deg)"
  }
  else{
    colorPanel.style.transform = `translateY(0px)`

    toggleButton.style.transform = "rotate(-180deg)"
  }

  isOpen = !isOpen
})